import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EligibilityStatusSchema = withDefaults({
  type: 'eligibility-status',
  fields: [
    { kind: 'attribute', name: 'employeeId' },
    { kind: 'attribute', name: 'applicationId' },
    { kind: 'attribute', name: 'lockBasis' },
    { kind: 'attribute', name: 'lockDate' },
    { kind: 'attribute', name: 'participantState' },
    { kind: 'attribute', name: 'employmentType' },
    { kind: 'attribute', name: 'deactivatedOn' },
    { kind: 'attribute', name: 'payDeactivatedEmployees' },
    { kind: 'attribute', name: 'ignorePolicies' },
    { kind: 'attribute', name: 'eligibilityPeriods' },
    { kind: 'attribute', name: 'withinEligibilityPeriod' },
    { kind: 'attribute', name: 'isEligible' },
  ],
});

export default EligibilityStatusSchema;
